import BasicActionTypes from '../types/app';

const initialBasicState = {
  data: {
    thankYouTitle: 'Your request has been submitted',
    thankYouBody:
      'Your appointment form has been sent to our intake team. We will review the details of your request and get back to you as soon as possible. \n\n During periods of high demand, the wait times might be longer than usual. In the meantime, if you have any further inquiries, please don’t hesitate to contact us by email',
    isMenuOpened: false,
  },
  loading: false,
  error: false,
};

export default (state = initialBasicState, action) => {
  switch (action.type) {
    case BasicActionTypes.SWITCH_MENU: {
      return {
        ...state,
        data: {
          ...state.data,
          isMenuOpened: !state.data.isMenuOpened,
        },
      };
    }
    default:
      return state;
  }
};
